import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { DataProvider } from "../data/data";
import { Headers, URLSearchParams } from '@angular/http';
import { Banner } from "../../models/banner";

const ROUTE = 'banners';

@Injectable()
export class BannerProvider extends DataProvider<Array<Banner>>{

    constructor() {
        super(ROUTE);
    }

    public async getBanners(): Promise<Array<Banner>> {
        return this.auth.get(ROUTE).then(x => x as Array<Banner>);
    }
}


// WEBPACK FOOTER //
// ./src/providers/banner/banner.ts